<template>
  <div class="configuration-notice">
    <slot />
  </div>
</template>

<style scoped lang="scss">
@import '@/stylesheets/global';

.configuration-notice {
  border-top: 2px solid map-get($background-color, dark);
  background-color: map-get($background-color, light);
  padding-top: bu(2);
}
</style>
